import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {connect} from 'react-redux';
import baseStyles from '../../PropertiesMenuStyles';
import { HyperlinkButton, renderModes } from './HyperlinkButton';

@Radium
export default class HyperlinkProperty extends Component {

  render() {
    const { selectedElements } = this.props;
    return (
      <div style={[baseStyles.menuContainer, this.props.first && baseStyles.menuContainerFirst]}>
        <div style={baseStyles.menuTitle}>Hyperlink</div>
        <div style={baseStyles.menuBody}>
          <HyperlinkButton mode={renderModes.VERTICAL} selectedElements={selectedElements}/>
        </div>
      </div>
    );
  }
}

HyperlinkProperty.propTypes = {
  selectedElements: PropTypes.array.isRequired
};